
String.prototype.removerCaracteresEspeciais = function (this: string) {
  var s = this;
  return s?.replace(/\D/g, '');
};

String.prototype.toCep = function (this: string) {
  var s = this;
  return s.removerCaracteresEspeciais();
};

String.prototype.toCNPJ = function (this: string) {
  var s = this;
  return s.removerCaracteresEspeciais();
};

String.prototype.toCPF = function (this: string) {
  var s = this;
  return s.removerCaracteresEspeciais();
};

String.prototype.toCnpjCpf = function (this: string) {
  var s = this;
  return s.removerCaracteresEspeciais();
};

String.prototype.toMoney = function (this: string) {
  var s = this;
  return s?.toString().replace('R$ ', '').replace(/\./g, '').replace(/\,/g, '.');
};

String.prototype.toMoneyVirgula = function (this: string) {
  var s = this;
  let val = s?.toString().replace('R$ ', '').replace(/\./g, ',');
  if (val) {
    let splitValor = val.split(',');
    if (splitValor.length == 2 && splitValor[1].length == 1)
      val = `${val}0`;

    if (splitValor.length == 1)
      val = `${val},00`;
  }
  return val;
};

Number.prototype.toMoney = function (this: number) {
  var s = this;
  return parseFloat(s?.toString().toMoney())
};

Number.prototype.toMoneyVirgula = function (this: number) {
  var s = this;
  return parseFloat(s?.toString().toMoneyVirgula())
};
